import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils.js";

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "glass rounded-[var(--radius-lg)] p-6 shadow-[var(--shadow-glass)] transition-[background,border-color,box-shadow] duration-200",
        className,
      )}
      {...props}
    />
  );
}
